import { Checkbox, SectionMessage, Text } from '@billy/design-system'
import { ChangeEvent, ReactElement, useCallback } from 'react'
import { useTranslation } from 'react-i18next'

import { useEInvoicingAddressForm } from '../../../../../../contexts/eInvoicingAddressFormContext'
import * as Styled from './styles'

export const EInvoicingAddressingLineNotification = (): ReactElement => {
  const { t } = useTranslation()

  const { isUnregisteredAddressingLineAcknowledged, setIsUnregisteredAddressingLineAcknowledged } =
    useEInvoicingAddressForm()

  const handleAcknowledgementChange = useCallback(
    (event: ChangeEvent<HTMLInputElement>) => {
      setIsUnregisteredAddressingLineAcknowledged(event.target.checked)
    },
    [setIsUnregisteredAddressingLineAcknowledged],
  )

  return (
    <SectionMessage
      icon="info"
      sideActions={
        <Checkbox checked={isUnregisteredAddressingLineAcknowledged} onChange={handleAcknowledgementChange}>
          {t(
            'external_invoices.send_as_e_invoice.modal.field.addressing_line.notification.not_registered.acknowledgement',
          )}
        </Checkbox>
      }
      variant="warning"
    >
      <Styled.AddressingLineNotificationTitle>
        <Text as="span" variant="bodyMD" weight="semiBold" inheritColor>
          {t('external_invoices.send_as_e_invoice.modal.field.addressing_line.notification.not_registered.title')}
        </Text>
      </Styled.AddressingLineNotificationTitle>
      {t('external_invoices.send_as_e_invoice.modal.field.addressing_line.notification.not_registered.description')}
    </SectionMessage>
  )
}
